"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllPersonas = exports.createGetAllPersonas = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatPersonas = _interopRequireDefault(require("reference-resolvers/formatters/formatPersonas"));

var createGetAllPersonas = function createGetAllPersonas(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get('contacts/v1/personas').then(_formatPersonas.default);
  };
};

exports.createGetAllPersonas = createGetAllPersonas;
var getAllPersonas = createGetAllPersonas({
  httpClient: _apiClient.default
});
exports.getAllPersonas = getAllPersonas;